(function(){
    'use strict'; 
    angular.module('app').controller('ThirdPartyAccountingAppDetailsController', ThirdPartyAccountingAppDetailsController);
    ThirdPartyAccountingAppDetailsController.$inject = [
        '$routeParams',
        'AccountingService',
        'toastr',
        '$location',
        '$q',
        'ClientService'
    ];

    function ThirdPartyAccountingAppDetailsController(
        $routeParams,
        AccountingService,
        toastr,
        $location,
        $q,
        ClientService
    ){
        const vm = this; 
        
        vm.accountingAppId = $routeParams.id != 'new' ? $routeParams.id : null;
        vm.accountingAppDetails = {
            parameters: []
        };

        vm.setParameters = setParameters;
        vm.getCustomers = getCustomers;
        vm.getAccountingApps = getAccountingApps;
        vm.connect = connect; 
        vm.update = update;
        vm.cancel = cancel;

        init();
        function init(){
            vm.isLoading = true;
            $q.all([getAccountingApps()]).then(data => {
                if(vm.accountingAppId) {
                    getAccountingAppDetails();
                }
                vm.isLoading = false;
            });
        }

        function getAccountingApps(){
            const defer = $q.defer();
            AccountingService.CustomerAccountingApps.getAvailableAccounting(data => {
                vm.accountingApps = data;
                defer.resolve(data.content);
            }, error => {
                defer.reject(error.message);
                toastr.error(error.message, 'Error');
            });
            return defer.promise;
        }

        function getCustomers(data = null){
            const defer = $q.defer();
            const defaultParams = {
                size: 20, 
                page: 0, 
                sort: 'id,desc'
            }; 
            const params = data ? angular.extend(defaultParams, {name: data}) : defaultParams; 

            ClientService.Company.getAll(success => {   
                vm.customers = success.content;
                defer.resolve(success.content);
            }, error => {
                defer.reject(error);
                toastr.error(error.message, "Error");
            }, {
                size: 20, 
                page: 0, 
                sort: 'id,desc', 
                name: data 
            }, params);
            return defer.promise;
        }

        function getAccountingAppDetails(){
            AccountingService.CustomerAccountingApps.getById(success => {
                vm.accountingAppDetails.appId = vm.accountingApps.find(item => item.appId === success.appId);
                vm.accountingAppDetails.customer = success.customer;
                vm.accountingAppDetails.parameters = success.parameters.sort((a, b) => {
                    return a.name < b.name ? -1 : 1;
                });
                vm.instructions = `/templates/pages/api-access/accounting-app-instructions/${success.appId}.html`;
            }, error => {
                toastr.error(error.message, 'Error');
            }, vm.accountingAppId)
        }

        function setParameters(accountingApp) {
            vm.accountingAppDetails.parameters = accountingApp.parameters;
        }

        function connect(){
            vm.loading = true;
            AccountingService.CustomerAccountingApps.create(data => {
                vm.loading = false;
                vm.accountingAppDetails = data;
                getAuthorization(data.id);
                toastr.success('Connection created', 'Success');
            }, error => {
                vm.loading = false;
                toastr.error(error.message, "Error");
            }, cleanPayload(vm.accountingAppDetails));
        }

        function update(){
            vm.loading = true; 
            AccountingService.CustomerAccountingApps.update(data => {
                vm.loading = false;
                getAuthorization(data);
                toastr.success('Connection details update', 'Success');
            }, error => {
                vm.loading = false; 
                toastr.error(error.message, "Error"); 
            }, cleanPayload(vm.accountingAppDetails), vm.accountingAppId);
        }

        function getAuthorization(data){
            const client = data.parameters.find(param => param.name === 'clientId');
            const redirectUrl = 'https://api-demo.bbamastro.com/accounting-service/customer-accounting/oauth/callback';

            AccountingService.CustomerAccountingApps.xeroAuthorization(success => {
                toastr.success('Authorization token is generated.');
            }, error => {
               toastr.error(error.message, 'Error');
            }, {
                client_id: client.value,
                redirect_uri: redirectUrl,
                response_type: 'code',
                scope: 'openid%20email%20profile%20offline_access%20accounting.transactions%20accounting.contacts',
                state: 'MSwzLGh0dHBzOi8vYXBpLWRlbW8uYmJhbWFzdHJvLmNvbS9hY2NvdW50aW5nLXNlcnZpY2UvYWRtaW4vY3VzdG9tZXItYWNjb3VudGluZy8z'
            });
        }

        function cleanPayload(data){   
            return {
                appId: data.appId.appId,
                customerId: data.customer.id, 
                parameters: data.parameters.map(data=>{
                    return {
                        name: data.name, 
                        value: data.value
                    }
                })
            }
        }

        function cancel(){
            $location.path('/api-access/third-party-accounting-app');
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/api-access/ThirdPartyAccountingAppDetailsController.js